import Api from './api';



export const getAll = async (hirerId) => { 
  let data = []
  await Api.get(`/twotalkregistrationnumberrequests/all`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};


export const getByOrganizationId = async (orgId) => { 
  let data = []
  await Api.get(`/twotalkregistrationnumberrequests/org/${orgId}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};
